'use strict';

module.exports = /*@ngInject*/

/**
 * Directive that listens for orientation change event.
 * Pass in different actions to directive attribute and desired functionality in switch statement
 *
 * Actions
 * reloadRoute: reloads current route (refreshes view without reloading entire page)
 */

function($window, $route) {
    return {
        scope: {
            action: '@orientationChange'
        },
        link: function(scope, element, attrs) {
            $window.addEventListener('orientationchange', function() {
                switch (scope.action) {
                    case 'reloadRoute':
                        $route.reload();
                    break;

                    // add in additional cases as needed...
                }
            }, false);
        }
    };
};
